module.exports = __webpack_public_path__ + "76c29ef26c59ef8c12a211718db8c7a8.svg";